import { buildKerioDavUrls, getKerioMailboxEmail, getMailServerHost, } from "@apps/client-sdk";
import { el } from "../dom.js";
function copyRow(label, value, hint) {
    const row = el("div", "dav-url-row");
    row.append(el("label", "dav-url-label", label));
    if (hint) {
        row.append(el("p", "hint", hint));
    }
    const controls = el("div", "inline-add");
    const input = el("input", "input");
    input.type = "text";
    input.readOnly = true;
    input.value = value;
    input.setAttribute("aria-label", label);
    const copyBtn = el("button", "btn btn-secondary btn-sm", "Copy");
    copyBtn.type = "button";
    copyBtn.addEventListener("click", () => {
        void (async () => {
            try {
                await navigator.clipboard.writeText(value);
                const previous = copyBtn.textContent;
                copyBtn.textContent = "Copied";
                window.setTimeout(() => {
                    copyBtn.textContent = previous;
                }, 1500);
            }
            catch {
                input.focus();
                input.select();
            }
        })();
    });
    controls.append(input, copyBtn);
    row.append(controls);
    return row;
}
function stepsList(title, steps) {
    const wrap = el("div", "dav-steps mt");
    wrap.append(el("h3", undefined, title));
    const ol = el("ol", "dav-steps-list");
    for (const step of steps) {
        ol.append(el("li", undefined, step));
    }
    wrap.append(ol);
    return wrap;
}
function renderUrls(urls) {
    const block = el("div", "dav-urls");
    block.append(copyRow("CalDAV URL (Thunderbird)", urls.caldavThunderbird, "Use this location when adding a network calendar in Thunderbird 78+."));
    block.append(copyRow("CalDAV URL (generic)", urls.caldav, "Alternate Kerio path — try this if Thunderbird cannot discover calendars."));
    block.append(copyRow("CardDAV URL", urls.carddav, "Use this when adding a CardDAV address book in Thunderbird."));
    block.append(copyRow("Username", urls.username, "Password is your Kerio account password (or app password if 2FA is enabled)."));
    return block;
}
export function renderKerioDavHelperSection(options) {
    const section = el("section", "card");
    section.append(el("h2", undefined, "Calendar & Contacts"));
    const status = el("p", "muted", "Loading…");
    section.append(status);
    const body = el("div", "dav-helper");
    body.hidden = true;
    section.append(body);
    void (async () => {
        try {
            const [host, email] = await Promise.all([
                getMailServerHost(options.storage),
                getKerioMailboxEmail(options.storage),
            ]);
            if (!host) {
                status.textContent =
                    "Kerio server host is missing for this account. Unpair and pair again from the portal.";
                status.className = "error";
                return;
            }
            if (!email) {
                status.textContent =
                    "A full email address is required to build CalDAV/CardDAV URLs. Re-pair this Kerio account, or add the mailbox email under Mailbox addresses.";
                status.className = "error";
                return;
            }
            const urls = buildKerioDavUrls(host, email);
            body.replaceChildren();
            body.append(el("p", "hint", "Thunderbird can sync Kerio calendars and contacts over CalDAV and CardDAV. Outlook does not support these protocols for Kerio — use the Kerio Outlook Connector (KOFF) instead."));
            body.append(renderUrls(urls));
            body.append(stepsList("Add calendar in Thunderbird", [
                "Open the Calendar tab.",
                "Choose New Calendar → On the Network.",
                "Paste the CalDAV URL (Thunderbird) as the location.",
                "Sign in with the username above and your Kerio password.",
            ]));
            body.append(stepsList("Add contacts in Thunderbird", [
                "Open Address Book.",
                "Choose New Address Book → Add CardDAV Address Book (wording may vary by Thunderbird version).",
                "Paste the CardDAV URL and continue.",
                "Sign in with the same username and Kerio password.",
            ]));
            body.hidden = false;
            status.hidden = true;
        }
        catch (error) {
            status.textContent =
                error instanceof Error ? error.message : "Failed to build CalDAV/CardDAV URLs";
            status.className = "error";
        }
    })();
    return section;
}
